import axios from "@/axios.js";

function mapCountry(item) {
  if (!item) return null;

  return {
    ID: item.Id,
    Code: item.Code,
    NameAr: item.NameAr,
    NameEn: item.NameEn,
    IsActive: item.IsActive,

    // Id: item.Id,
    // IsDeleted: item.IsDeleted,
    // CreatedAt: item.CreatedAt,
    // UpdatedAt: item.UpdatedAt,
    // CreatedByUserID: item.CreatedByUserID,
    // ModifiedByUserID: item.ModifiedByUserID
  };
}

function mapCreateUpdatePayload(item) {
  return {
    Id: item.ID || 0,
    Code: item.Code || "",
    NameAr: item.NameAr || "",
    NameEn: item.NameEn || "",
    IsActive: item.IsActive !== undefined ? item.IsActive : true
  };
}

function getResponseData(response, fallback = null) {
  if (!response || !response.data) return fallback;
  return response.data.Data || fallback;
}

export default {
  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/Country/GetAll")
        .then((response) => {
          const raw = getResponseData(response, []);
          const payload = Array.isArray(raw) ? raw.map(mapCountry) : [];
          commit("SET_ITEMS", payload);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  addItem({ commit }, item) {
    const payloadToApi = mapCreateUpdatePayload(item);

    return new Promise((resolve, reject) => {
      axios
        .post("/api/Country/Add", payloadToApi)
        .then((response) => {
          const raw = getResponseData(response, payloadToApi);
          const payload = mapCountry(raw);
          commit("ADD_ITEM", payload);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  updateItem({ commit }, item) {
    const payloadToApi = mapCreateUpdatePayload(item);

    return new Promise((resolve, reject) => {
      axios
        .put("/api/Country/Update", payloadToApi)
        .then((response) => {
          const raw = getResponseData(response, payloadToApi);
          const payload = mapCountry(raw);
          commit("UPDATE_ITEM", payload);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  removeItem({ commit }, item) {
    const id = item && item.ID ? item.ID : item;

    return new Promise((resolve, reject) => {
      axios
        .delete("/api/Country/Delete/" + id)
        .then((response) => {
          commit("REMOVE_ITEM", id);
          resolve(response.data || response);
        })
        .catch((error) => reject(error));
    });
  }
};
